import {
	ADD_TRIPS_START,
	ADD_TRIPS_SUCCESS,
	ADD_TRIPS_ERROR,
	PREVIEW_TOUR_TRIP_START,
	PREVIEW_TOUR_TRIP_ERROR,
	PREVIEW_TOUR_TRIP_SUCCESS,
	GET_TRIP_DETAILS_START,
	GET_TRIP_DETAILS_ERROR,
	GET_TRIP_DETAILS_SUCCESS,
	TRIP_ADDITIONAL_JSON_VALUE,
	TRIP_ADDITIONAL_JSON_VALUE_SUCCESS,
	TRIP_ADDITIONAL_JSON_VALUE_ERROR,
} from "../Constant/ManageTripsConstant";

const initialState = {
	loading: false,
	data: [],
	previewData: [],
	tripDetails: [],
	tripadditional: [],
};

export default function ManageTripsReducer(
	state = { ...initialState },
	action
) {
	switch (action.type) {
		case ADD_TRIPS_START:
		case PREVIEW_TOUR_TRIP_START:
		case GET_TRIP_DETAILS_START:
			return {
				...state,
				loading: true,
			};
		case ADD_TRIPS_SUCCESS:
			return {
				...state,
				data: action.payload,
				tripDetails: action.payload,
				loading: false,
			};
		case PREVIEW_TOUR_TRIP_SUCCESS:
			return {
				...state,
				previewData: action.payload,
				loading: false,
			};
		case GET_TRIP_DETAILS_SUCCESS:
			return {
				...state,
				tripDetails: action.payload,
				loading: false,
			};
		case ADD_TRIPS_ERROR:
		case PREVIEW_TOUR_TRIP_ERROR:
		case GET_TRIP_DETAILS_ERROR:
			return {
				...state,
				loading: false,
				message: action.error.message,
			};
		case TRIP_ADDITIONAL_JSON_VALUE:
			return {
				...state,
				tripadditional: [],
			};
		case TRIP_ADDITIONAL_JSON_VALUE_SUCCESS:
			return {
				...state,
				tripadditional: action.payload,
			};

		case TRIP_ADDITIONAL_JSON_VALUE_ERROR:
			return {
				...state,
				tripadditional: [],
			};

		default:
			return state;
	}
}
